import React, { useContext, Fragment } from 'react';
import FooterModule from '../modules/FooterModule';
import NavBronson from './bronson/NavBronson';
import { withRouter } from 'react-router-dom';
// import { VehiclesContext } from '../contexts/VehiclesContext';
// import SimulationsRVO from './RentingVO/SimulationsRVO';
import AppBlocked from './AppBlocked';
import { useState } from 'react';

function Layout({ history, children }) {
    // const { showSimulationsRVO } = useContext(VehiclesContext);
    const [banned] = useState(false);
    return (
        <Fragment>
            <NavBronson availableLanguages={['ES', 'EN']} noHero={true} />
            {children}
            <FooterModule history={history}></FooterModule>
            <AppBlocked show={banned}></AppBlocked>
            {/* {showSimulationsRVO ?
                <SimulationsRVO
                ></SimulationsRVO>
                : null} */}
        </Fragment>
    );
}

export default withRouter(Layout);
